// extracted by mini-css-extract-plugin
export default {"zoomModal":"ida-z","image":"jda-z","button":"kda-z","isOverlayShown":"lda-z"};